import React from 'react';

import { GENDER_CHART } from 'constants/charts';
import ParticipationChart from 'components/charts/ParticipationChart';

const DemographicsReport = ({ questionId, startDate, endDate }) => {
  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <ParticipationChart
        titleText="How were the participants responding to your survey?"
        subtitleText="Based on gender and age"
        questionId={questionId}
        category="demographic_participation"
        startDate={startDate}
        colors={GENDER_CHART}
        endDate={endDate}
        height={250}
      />
    </div>
  );
};

export default DemographicsReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/demographicsReport.js